"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var tf = _interopRequireWildcard(require("@tensorflow/tfjs"));
var _legacyVideo = _interopRequireDefault(require("@entrylabs/legacy-video"));
var _mediaPipeUtils = _interopRequireDefault(require("../../util/mediaPipeUtils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t8 in e) "default" !== _t8 && {}.hasOwnProperty.call(e, _t8) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t8)) && (i.get || i.set) ? o(f, _t8, i) : f[_t8] = e[_t8]); return f; })(e, t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var mediaPipeUtils = _mediaPipeUtils["default"].getInstance();
var classes = exports.classes = ['ai_learning_image'];
var SCALAR_VALUE = 127.5;
var SIZE = 224;
var _type = /*#__PURE__*/new WeakMap();
var _url = /*#__PURE__*/new WeakMap();
var _labels = /*#__PURE__*/new WeakMap();
var _popup = /*#__PURE__*/new WeakMap();
var _result = /*#__PURE__*/new WeakMap();
var _axis = /*#__PURE__*/new WeakMap();
var _isPredicting = /*#__PURE__*/new WeakMap();
var _captureCanvas = /*#__PURE__*/new WeakMap();
var _captureTimeoutClear = /*#__PURE__*/new WeakMap();
var ImageLearning = /*#__PURE__*/function () {
  function ImageLearning(_ref) {
    var _this = this;
    var url = _ref.url,
      labels = _ref.labels,
      type = _ref.type;
    (0, _classCallCheck2["default"])(this, ImageLearning);
    _classPrivateFieldInitSpec(this, _type, null);
    _classPrivateFieldInitSpec(this, _url, '');
    _classPrivateFieldInitSpec(this, _labels, []);
    _classPrivateFieldInitSpec(this, _popup, null);
    _classPrivateFieldInitSpec(this, _result, []);
    _classPrivateFieldInitSpec(this, _axis, 0);
    _classPrivateFieldInitSpec(this, _isPredicting, false);
    _classPrivateFieldInitSpec(this, _captureCanvas, void 0);
    _classPrivateFieldInitSpec(this, _captureTimeoutClear, void 0);
    _classPrivateFieldSet(_type, this, type);
    _classPrivateFieldSet(_url, this, url);
    _classPrivateFieldSet(_labels, this, labels);
    this.load(url);
    Entry.addEventListener('stop', function () {
      _classPrivateFieldSet(_result, _this, []);
      _classPrivateFieldSet(_isPredicting, _this, false);
    });
    if (!isWebGlSupport()) {
      tf.setBackend('cpu');
    }
  }
  return (0, _createClass2["default"])(ImageLearning, [{
    key: "labels",
    get: function get() {
      return _classPrivateFieldGet(_labels, this);
    }
  }, {
    key: "getResult",
    value: function getResult(index) {
      var _classPrivateFieldGet2,
        _this2 = this;
      var result = _classPrivateFieldGet(_result, this).length ? _classPrivateFieldGet(_result, this) : ((_classPrivateFieldGet2 = _classPrivateFieldGet(_popup, this)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.result) || [];
      var defaultResult = {
        probability: 0,
        className: ''
      };
      if (index !== undefined && index > -1) {
        return result.find(function (_ref2) {
          var className = _ref2.className;
          return className === _classPrivateFieldGet(_labels, _this2)[index];
        }) || defaultResult;
      }
      return result[0] || defaultResult;
    }
  }, {
    key: "unbanBlocks",
    value: function unbanBlocks(blockMenu) {
      blockMenu.unbanClass("ai_learning_classification");
      if (_classPrivateFieldGet(_type, this)) {
        blockMenu.unbanClass("ai_learning_".concat(_classPrivateFieldGet(_type, this)));
      }
    }
  }, {
    key: "openInputPopup",
    value: function openInputPopup() {
      var _this3 = this;
      Entry.dispatchEvent('openMLInputPopup', {
        type: 'image',
        predict: function () {
          var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(canvas) {
            var _t, _t2, _t3;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _t = _classPrivateFieldSet;
                  _t2 = _result;
                  _t3 = _this3;
                  _context.next = 1;
                  return _this3.predict(canvas);
                case 1:
                  _t(_t2, _t3, _context.sent);
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function predict(_x) {
            return _predict.apply(this, arguments);
          }
          return predict;
        }(),
        url: _classPrivateFieldGet(_url, this),
        labels: _classPrivateFieldGet(_labels, this),
        setResult: function setResult(result) {
          _classPrivateFieldSet(_result, _this3, result);
        }
      });
    }
  }, {
    key: "getVideo",
    value: function getVideo() {
      if (_legacyVideo["default"].isInitialized) {
        return _legacyVideo["default"].video;
      }
      if (mediaPipeUtils.isInitialized) {
        return mediaPipeUtils.video;
      }
      return null;
    }
  }, {
    key: "startPredict",
    value: function () {
      var _startPredict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this4 = this;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!this.isLoaded || _classPrivateFieldGet(_isPredicting, this))) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return", false);
            case 1:
              _classPrivateFieldSet(_isPredicting, this, true);
              if (!this.captureCanvas) {
                _classPrivateFieldSet(_captureCanvas, this, document.createElement('canvas'));
                _classPrivateFieldGet(_captureCanvas, this).width = SIZE;
                _classPrivateFieldGet(_captureCanvas, this).height = SIZE;
              }
              _classPrivateFieldSet(_captureTimeoutClear, this, Entry.Utils.asyncAnimationFrame(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                var video, context, _t4, _t5, _t6;
                return _regenerator["default"].wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      video = _this4.getVideo();
                      if (video) {
                        _context2.next = 1;
                        break;
                      }
                      return _context2.abrupt("return");
                    case 1:
                      context = _classPrivateFieldGet(_captureCanvas, _this4).getContext('2d');
                      context.drawImage(video, 0, 0, SIZE, SIZE);
                      _t4 = _classPrivateFieldSet;
                      _t5 = _result;
                      _t6 = _this4;
                      _context2.next = 2;
                      return _this4.predict(_classPrivateFieldGet(_captureCanvas, _this4));
                    case 2:
                      _t4(_t5, _t6, _context2.sent);
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }))));
              return _context3.abrupt("return", _classPrivateFieldGet(_result, this));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function startPredict() {
        return _startPredict.apply(this, arguments);
      }
      return startPredict;
    }()
  }, {
    key: "predict",
    value: function () {
      var _predict2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(canvas) {
        var tensor, logits, result;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              tf.engine().startScope();
              _context4.next = 1;
              return this.preprocess(canvas);
            case 1:
              tensor = _context4.sent;
              logits = this.model.predict(tensor);
              _context4.next = 2;
              return this.namePredictions(logits);
            case 2:
              result = _context4.sent;
              logits.dispose();
              tf.engine().endScope();
              return _context4.abrupt("return", result);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function predict(_x2) {
        return _predict2.apply(this, arguments);
      }
      return predict;
    }()
  }, {
    key: "stopPredict",
    value: function stopPredict() {
      _classPrivateFieldSet(_result, this, []);
      _classPrivateFieldSet(_isPredicting, this, false);
      _classPrivateFieldGet(_captureTimeoutClear, this) && _classPrivateFieldGet(_captureTimeoutClear, this).call(this);
    }
  }, {
    key: "namePredictions",
    value: function () {
      var _namePredictions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(logits) {
        var _this5 = this;
        var values, _t7;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _t7 = Array;
              _context5.next = 1;
              return logits.data();
            case 1:
              values = _t7.from.call(_t7, _context5.sent);
              return _context5.abrupt("return", values.map(function (probability, index) {
                return {
                  className: _classPrivateFieldGet(_labels, _this5)[index] || index,
                  probability: probability
                };
              }).sort(function (a, b) {
                return a.probability > b.probability ? -1 : a.probability < b.probability ? 1 : 0;
              }));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function namePredictions(_x3) {
        return _namePredictions.apply(this, arguments);
      }
      return namePredictions;
    }()
  }, {
    key: "preprocess",
    value: function () {
      var _preprocess = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(canvas) {
        var _this6 = this;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", tf.tidy(function () {
                var offset = tf.scalar(SCALAR_VALUE);
                return tf.browser.fromPixels(canvas).toFloat().sub(offset).div(offset).expandDims(_classPrivateFieldGet(_axis, _this6));
              }));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function preprocess(_x4) {
        return _preprocess.apply(this, arguments);
      }
      return preprocess;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(url) {
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return tf.loadLayersModel(url);
            case 1:
              this.model = _context7.sent;
              this.isLoaded = true;
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function load(_x5) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "reload",
    value: function () {
      var _reload = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(url) {
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 1;
              return tf.loadLayersModel(url || _classPrivateFieldGet(_url, this));
            case 1:
              this.model = _context8.sent;
              this.isLoaded = true;
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function reload(_x6) {
        return _reload.apply(this, arguments);
      }
      return reload;
    }()
  }]);
}();
var _default = exports["default"] = ImageLearning;
function isWebGlSupport() {
  try {
    var currentCanvas = document.createElement('canvas');
    return !!currentCanvas.getContext('webgl', {
      premultipliedalpha: false
    });
  } catch (e) {
    console.log('error', e);
    return false;
  }
}